<script setup>
const props = defineProps({
  modelValue: Boolean,
  title: {
    type: String,
    default: 'Confirm'
  },
  text: {
    type: String,
    default: 'Are you sure?'
  },
  cancelBtnName: {
    type: String,
    default: 'No'
  },
  submitBtnName: {
    type: String,
    default: 'Yes'
  },
  submitConfirm: {
    type: Boolean,
    default: false
  },
  confirmText: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'onCancel', 'onSubmit'])
const submitEnabled = ref(false)

const closeDialog = () => {
  emit('update:modelValue', false)
}

const onCancel = () => {
  emit('onCancel')
  closeDialog()
}

const onSubmit = () => {
  emit('onSubmit')
  closeDialog()
}
</script>

<template>
  <VDialog
    id="confirm-dialog"
    :model-value="modelValue"
    persistent
    max-width="600"
    @update:model-value="emit('update:modelValue')"
    @contextmenu.prevent
  >
    <DialogCloseBtn @click="closeDialog" />

    <VCard>
      <template #title>
        <span>
          {{ title }}
        </span>
      </template>
      <template #default>
        <VCardText class="text-center">
          {{ text }}
        </VCardText>
        <VCardText class="d-flex justify-space-between" v-if="submitConfirm">
          <VCheckbox v-model="submitEnabled" />
          <div class="pa-1">
           {{ confirmText }}
          </div>
        </VCardText>
        <VCardText class="d-flex justify-space-between">
          <VBtn
            color="secondary"
            @click="onCancel"
          >
            {{ cancelBtnName }}
          </VBtn>
          <VBtn
            v-if="submitConfirm"
            :disabled="!submitEnabled"
            @click="onSubmit"
          >
            {{ submitBtnName }}
          </VBtn>
          <VBtn
            v-else
            @click="onSubmit"
          >
            {{ submitBtnName }}
          </VBtn>
        </VCardText>
      </template>
    </VCard>
  </VDialog>
</template>
